// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2nEMK","calendarButtons":"ClockData_calendarButtons__3ormi"};